<template>
    <div>
        <div class="form-group col-12">
            <label for="text">Text</label>

            <input
                id="text"
                v-model="footerLink.text"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('text')
                }"
                dir="auto"
                placeholder="Text"
            />

            <div class="invalid-feedback">
                {{ getError('text') }}
            </div>
        </div>

        <div class="form-group col-12">
            <label for="link">Url</label>

            <input
                id="link"
                v-model="footerLink.link"
                type="link"
                class="form-control"
                :class="{
                    'is-invalid': hasError('link')
                }"
                dir="auto"
                placeholder="link"
            />

            <div class="invalid-feedback">
                {{ getError('link') }}
            </div>
        </div>

        <div class="form-group col-12">
            <label class="label_title"> Column </label>

            <v-select
                v-model="footerLink.columnId"
                :reduce="column => column.id"
                label="title"
                :class="{
                    'is-invalid': hasError('columnId')
                }"
                :options="footerColumns"
                :clearable="false"
            />

            <div class="invalid-feedback">
                {{ getError('columnId') }}
            </div>
        </div>

        <div class="form-group col-12">
            <label for="text">Order</label>

            <v-select
                v-model="footerLink.order"
                :class="{
                    'is-invalid': hasError('order')
                }"
                :disabled="!orderOptions.length"
                :options="orderOptions"
                :clearable="false"
            />

            <div class="invalid-feedback">
                {{ getError('order') }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            footerLink: {},
            footerColumns: [],
            orderOptions: [],
            footerLinkColumnId: null
        };
    },

    watch: {
        footerLink() {
            this.$emit('input', this.footerLink);
        },

        async 'footerLink.columnId'(value, oldValue) {
            try {
                let { count } = await this.getColumnCount(value);

                if (
                    !this.editMode ||
                    (this.editMode &&
                        this.footerLink.columnId !== this.footerLinkColumnId)
                ) {
                    count += 1;
                }

                this.orderOptions = Array.from(
                    { length: count },
                    (_, i) => i + 1
                );

                if (this.editMode && !oldValue) {
                    return;
                }

                this.footerLink.order = count;
            } catch (error) {
                this.orderOptions = [];

                console.error(error);

                this.$toasterError();
            }
        }
    },

    async mounted() {
        this.footerLink = { ...this.value };

        if (this.editMode) {
            this.footerLinkColumnId = this.footerLink.columnId;
        }

        try {
            const { rows } = await this.getFooterColumns();

            this.footerColumns = rows;
        } catch (error) {
            this.$toasterError();

            console.error(error);
        }
    },

    methods: {
        ...mapActions({
            getFooterColumns: 'footerColumns/index',
            getColumnCount: 'footerLinks/getColumnCount'
        }),

        hasError(key) {
            return (
                this.validation.footerLink[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.footerLink,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
